module.exports = __webpack_public_path__ + "img/profile_img2.348c67df.gif";